<div
  id="uzd-protocol"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="pro_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="pro_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серцебиття:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="pro_sertse">
            <option value="ритмічне">ритмічне</option>
            <option value="аритмічне">аритмічне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧСС:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="pro_chss" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рухи:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="pro_moves" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не визначаються', 'pro_dilyanku')"> не визначаються </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('визначаються', 'pro_dilyanku')"> визначаються </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ділянки відшарування плідного яйця:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="pro_dilyanku"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' не підвищений ', 'pro_tonus')"> не підвищений </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' підвищений ', 'pro_tonus')"> підвищений </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' по передній стінці ', 'pro_tonus')"> по передній стінці </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' по задній стінці ', 'pro_tonus')"> по задній стінці </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Тонус мінометрію:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="pro_tonus"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
